import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPropilot = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.844 6.15485C14.9887 6.15497 15.9162 7.06698 15.9162 8.19196C15.9162 9.31697 14.9887 10.2289 13.844 10.2291H7.67697L6.76682 15.8043H4.94455L6.21213 8.51324H13.844C14.0018 8.51308 14.1389 8.34979 14.1389 8.19196C14.1388 8.03415 14.0017 7.87083 13.844 7.87067H8.69748L8.94748 6.15485H13.844ZM13.9504 12.4449H9.55392L9.02267 15.8043H7.28537L8.0881 10.73H13.9504V12.4449ZM13.9865 3.93903C16.3189 3.95822 18.2043 5.85504 18.2043 8.19196C18.2043 10.5407 16.3001 12.4447 13.9514 12.4449V10.73C15.3526 10.7298 16.4885 9.59324 16.4885 8.19196C16.4884 6.79071 15.3526 5.65508 13.9514 5.65485H8.98361L9.23361 3.93903H13.9865Z",
			fill: "#0D2976"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5484 14.1935L14.2454 15.8417L16.129 16.4516L14.2454 17.0615L13.5484 18.7097L12.8514 17.0615L10.9677 16.4516L12.8514 15.8417L13.5484 14.1935Z",
			fill: "#0D2976"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.87097 4.51614L4.39373 6.16433L5.80645 6.77421L4.39373 7.38409L3.87097 9.03227L3.34821 7.38409L1.93549 6.77421L3.34821 6.16433L3.87097 4.51614Z",
			fill: "#0D2976"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.09677 1.29031L7.61953 2.46759L9.03225 2.90322L7.61953 3.33885L7.09677 4.51612L6.57401 3.33885L5.16129 2.90322L6.57401 2.46759L7.09677 1.29031Z",
			fill: "#0D2976"
		})
	]
});
export default SvgPropilot;
